import axios from '../axios'

const getCategoryList = params => axios({
  url: '/customer/recycle/product/getCategories',
  method: 'get',
  params
})
const getBrandList = params => axios({
  url: '/customer/recycle/product/getBrands',
  method: 'get',
  params
})
const phoneModelList = data => axios({
  url: '/customer/recycle/product/getProducts',
  method: 'post',
  data
})
const searchPhoneModel = data => axios({
  url: '/customer/recycle/product/search',
  method: 'post',
  data
})

const getProduct = params => axios({
  url: '/customer/recycle/product/getProduct',
  method: 'get',
  params
})

const officialSubmit = data => axios({
  url: '/customer/recycle/order/official/submit',
  method: 'post',
  data
})

const checkQrCode = params => axios({
  url: '/customer/recycle/promotion/checkQrCode',
  method: 'get',
  params
})

const evaluationCard = params => axios({
  url: '/customer/recycle/order/evaluationCard',
  method: 'get',
  params
})

const collectUserInfo = data => axios({
  url: '/customer/recycle/order/collect/user-info',
  method: 'post',
  data
})

const collected = params => axios({
  url: '/customer/recycle/order/collected',
  method: 'get',
  params
})


export {
  checkQrCode,
  collected,
  collectUserInfo,
  evaluationCard,
  getBrandList,
  getCategoryList,
  getProduct,
  officialSubmit,
  phoneModelList,
  searchPhoneModel}
